import { render, staticRenderFns } from "./AutocompleteMultiple.vue?vue&type=template&id=0850467b&"
import script from "./AutocompleteMultiple.vue?vue&type=script&lang=js&"
export * from "./AutocompleteMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports